module.exports = __webpack_public_path__ + "static/img/kurki_collective256.58adebf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/kurki_collective256.png
// module id = NNrY
// module chunks = 1